import React, { useState } from 'react';
import { Dropdown, Menu, Row, Space } from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { DownOutlined, CheckOutlined } from '@ant-design/icons';
import { DoneRounded, ArrowDropDownRounded, SearchRounded } from "@mui/icons-material";
import EditableItem from "./EditableItem";

const HoverMenu = ({ extraItems, onToggleExtraItems, initialSelectedItems, setShowSearch }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState(initialSelectedItems || []);

  const handleMenuClick = (e) => {
    const itemId = e.key;
    setSelectedItems(current =>
      current.includes(itemId) ? current.filter(id => id !== itemId) : [...current, itemId]
    );
  };

  const handleVisibleChange = flag => {
    setMenuVisible(flag);
  };

  const handleSubmit = () => {
    onToggleExtraItems(selectedItems); // Pass all selected items at once
    setMenuVisible(false); // Optionally close the menu after submission
  };

  const menu = (
    <Menu multiple onClick={handleMenuClick}>
      {Array.isArray(extraItems) && extraItems.length > 0 && extraItems.map(item => (
        <Menu.Item key={item.id} icon={selectedItems.includes(item.id) ? <CheckOutlined /> : null}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  if (!extraItems?.length>0){
      return null;
  }
  return (
        <Space>
            <Dropdown
            overlay={menu}
            trigger={['click']}
            onVisibleChange={handleVisibleChange}
            visible={menuVisible}
          >
            <Button variant={'text'} endIcon={<ArrowDropDownRounded fontSize={'large'} />} type={'primary'} className="ant-dropdown-link square" onClick={e => e.preventDefault()}>
              More Options
            </Button>
          </Dropdown>
          <Button className={'square'} startIcon={<DoneRounded />} onClick={handleSubmit} variant={!selectedItems.length ? 'text' : 'contained'}>
            Submit
          </Button>
        </Space>
  );
};

const ItemController = ({ items, itemColors, onRemove, extraItems, onToggleExtraItems,
                            initialSelectedItems, setShowSearch, showAll=false }) => {
  const MAX_VISIBLE_ITEMS = 3;  // Maximum visible items before showing overflow
  const [showAllItems, setShowAllItems] = useState(showAll);

  // Handle toggle overflow logic
  const visibleItems = showAllItems ? items : items.slice(0, MAX_VISIBLE_ITEMS);
  const remainingItemsCount = items.length - MAX_VISIBLE_ITEMS;

  let leftItems = visibleItems.map(item => (
    <EditableItem
      key={item.id}
      item={item}
      color={itemColors?.[item.id] ?? '#1890ff'}
      onRemove={onRemove}
    />
  ));

  // Overflow button to show remaining items
  const handleShowAllToggle = () => setShowAllItems(!showAllItems);

  return (
    <Row justify={'space-between'} className={'pl-6 py-2 round-2'} >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxWidth: '80%' }}>
        {leftItems}
        {remainingItemsCount > 0 && !showAllItems && (
          <Button onClick={handleShowAllToggle} color="primary" variant="text" size={'small'} className={'round'}>
            +{remainingItemsCount} more
          </Button>
        )}
      </div>
      <Space>
        <HoverMenu
          extraItems={extraItems}
          onToggleExtraItems={onToggleExtraItems}
          initialSelectedItems={initialSelectedItems}
          setShowSearch={setShowSearch}
        />
      </Space>
    </Row>
  );
};

export default ItemController;
